import { CheckedState } from '@radix-ui/react-checkbox';
import { ColumnDef } from '@tanstack/react-table';

import { Checkbox } from '../core/Checkbox';
import { Actions } from './action-column/actions';

export const columns: (
    t: (key: string) => string,
    items: any,
    columns: any,
    selectedRows: any[],
    areAllRowsSelected: boolean,
    allItemsSelected: boolean,
    selectionLocked: boolean,
    handleSelectAll: (checked: CheckedState)=> void,
    _handleSelectedItems: (item: any)=> void,
    isCatalogTable: boolean,
    redirectToItemDetail?: (item:any) => void,
    showEditor?: (row: any, primaryKey__?:string, editorState?: { onShowItemDetails: true }, items?:any) => void,
    deleteItem?: (row: any) => void,
    showItemReview?: (item: any) => void,
) => ColumnDef<any>[] = (t,
    items,
    columns,
    selectedRows,
    areAllRowsSelected,
    allItemsSelected,
    selectionLocked,
    handleSelectAll,
    _handleSelectedItems,
    isCatalogTable = false,
    redirectToItemDetail,
    showEditor,
    deleteItem,
    showItemReview) => [
    {
        accessorKey: 'select',
        enableSorting: false,
        meta: {
            leftPinned: true,
            draggable: false,
            cellClassName: 'tw-p-0 tw-h-full tw-text-center',
        },
        // Global select-all disables the checkboxes. Leaving that mode keeps
        // the concrete watchlist; it does not clear it.
        // Layout matches the Bulk Subscription entries dialog (40px centered box).
        header: () => (
            <div className="tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10">
                <Checkbox
                    id="select-all"
                    isChecked={areAllRowsSelected}
                    disabled={selectionLocked}
                    onCheckedChange={(checked)=> {
                        handleSelectAll(checked);
                    }}
                />
            </div>
        ),
        size: 40,
        enableResizing: false,
        cell: (row: any) => {
            return (
                <div className="tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10">
                    <Checkbox
                        isChecked={allItemsSelected || selectedRows.find((primaryKey: string)=> primaryKey === row.row.original.primaryKey__) !== undefined}
                        disabled={selectionLocked}
                        onCheckedChange={() => _handleSelectedItems(row.row.original)}
                    />
                </div>
            );
        },
        getCellProps: () => ({
            className: 'tw-sticky tw-left-0 tw-bg-white tw-z-10',
        }),
    },
    ...columns,
    {
        accessorKey: 'actions',
        header: t('ACTIONS'),
        meta: {
            pinned: true,
        },
        size: isCatalogTable? 130 : 295,
        enableSorting: false,
        enableResizing: false,
        cell: (row: any) => {
            {
                return <Actions
                    row={row}
                    isCatalogTable={isCatalogTable}
                    redirectToItemDetail={redirectToItemDetail}
                    showEditor={showEditor}
                    deleteItem={deleteItem}
                    showItemReview={showItemReview}
                    items={items}/>;
            }
        },
    },
];
